import ConfigManager from "./config-manager.connect";

export default ConfigManager;



// WEBPACK FOOTER //
// ./src/components/common/config-manager/index.js